const creditCardManagement = {
  removeCard: 'Remove',
};

export default creditCardManagement;
